export default {
  title: 'Applicant Lock Config Management',
  menu: 'Applicant Lock Config Management',
  label: {
    status: 'Applicant Status',
    lockTime: 'Lock Type & Time',
    remindConfig: 'Remind Frequency Rule',
    hasConfig: {
      has: 'Configured',
      not: 'Not Configured'
    }
  },
  placeholder: {
    lockTime: 'Please input lock time',
    remindConfig: 'Please input remind frequency rule'
  },
  btn: {
    deleteConfig: 'Delete',
    saveConfig: 'Save',
    addConfig: 'Add'
  },
  message: {
    deleteSuccess: 'Delete Success',
    cannotSaveEmpty: 'Please configure at least one locking rule',
    lockTypeIsRequired: 'Lock type is required',
    remindDaysLessThanLockDays: 'Locking days cannot be less than the sum of reminder frequency days',
    remindConfigIsNotInt: 'Reminder frequency should be an integer',
    lockTimeIsNotInt: 'Locking days should be an integer greater than one',
    invalidRemindConfig: 'The reminder frequency is invalid, and can only contain numbers and "+"',
    checkConfigList: 'Error in the configuration table, please check',
    remindConfigRuleTip: 'When the lock time is 5 days, it needs to be configured as 2 + 2 + 1 if it needs to be reminded on the second day, the fourth day and the fifth day\nWhen infinity locked, it needs to be reminded once every 5 days, then the configuration is 5',
    confirmDelete: 'Are you sure to delete this configuration?'
  },
  lockType: {
    RELEASE: 'Release',
    DAY_LOCK: 'Lock',
    INFINITY_LOCK: 'Infinity Lock'
  }
}
